
interface ServiceToggleProps {
  activeService: 'drafting' | 'takeoff';
  onToggle: (service: 'drafting' | 'takeoff') => void;
}

export default function ServiceToggle({ activeService, onToggle }: ServiceToggleProps) {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Choose Your Service Type
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select between our comprehensive drafting services or detailed takeoff and estimation solutions
          </p>
        </div>
        
        <div className="flex justify-center">
          <div className="inline-flex bg-gray-100 rounded-full p-1.5">
            <button
              onClick={() => onToggle('drafting')}
              className={`px-8 py-3 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap ${
                activeService === 'drafting'
                  ? 'bg-[#e18033] text-white shadow-lg'
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              <i className="ri-pencil-ruler-2-line mr-2"></i>
              Drafting Services (12+)
            </button>
            <button
              onClick={() => onToggle('takeoff')}
              className={`px-8 py-3 rounded-full text-base font-semibold transition-all duration-300 whitespace-nowrap ${
                activeService === 'takeoff'
                  ? 'bg-[#e18033] text-white shadow-lg'
                  : 'text-gray-700 hover:text-gray-900'
              }`}
            >
              <i className="ri-calculator-line mr-2"></i>
              Takeoff Services (3)
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
